import { memo, useEffect, useReducer, useState } from "react";
import ContentReceiver from "../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";
import LineChart from './DasboardComponents/Charts/LineChart';
import ClusteredStackedColumnChart from "./DasboardComponents/Charts/ClusteredStackedColumnChart";
import DonutChart from "./DasboardComponents/Charts/DonutChart";
import AreaChart from "./DasboardComponents/Charts/AreaChart";
import BarChart from "./DasboardComponents/Charts/BarChart";
import Table from "../Setup/Shared/Table";
import { ServerRequestProtected } from "../../utils/ServerDataRequest";
import { enumUtil } from "../../utils/Enum";
import AmountFormatter from "../../utils/AmountFormatter";
import AppointmentsBarChart from "./DasboardComponents/BarChart/AppointmentsBarChart";
import useSidebarSubMainTab from "../shared/HandleOpenSidebarSubTab/useSidebarSubMainTab";
import DatePicker from "../General/DatePicker"
import CalendaRangeInput from '../General/CalendarRangeInput'
import useDashboardFilterHook from "./DasboardComponents/Shared/useDashboardFilterHook";
import { useSelector } from "react-redux";
import DownloadCSVLink from "../../utils/DownloadCSVLink";
import Loader from "../shared/Loader/Loader";
import { useRef } from "react";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import GridColumnHeader from "../Setup/Shared/GridColumnHeader";
import SuperSearchList from "../shared/SuperSearch/SuperSearchList";
import isNull from "../../utils/NullChecking";
// import useHandleOpenNewBrowserTab from "../shared/NewTabBrowser/useHandleOpenNewBrowserTab";
import MultiLineChart from "./DasboardComponents/Charts/MultiLineChart";
import NoDataFound from "../shared/NoDataFound/NoDataFound";
import { SimpleQuestionIcon } from "../shared/IconsComponent/icons";
import BillingPerformance from "./DasboardComponents/Components/BillingPerformance";
import KPISection from "./DasboardComponents/Components/KPISection";
import FinancialSummary from "./DasboardComponents/Components/FinancialSummary";
import Aging from "./DasboardComponents/Components/Aging";
import PaymentReceived from "./DasboardComponents/Components/PaymentReceived";
// import { display } from "html2canvas/dist/types/css/property-descriptors/display";


const Dashboard = () => {
  let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
  let blinker = useSelector(state => state.BlinkerReducer);
  const [isFirstRender, setIsFirstRender] = useState(true);



  //// by yaseen 

  const BaseDD = [
    { value: "DOS", display: "Date of Service" },
    { value: "EntryDate", display: "Entry Date" },
    { value: "SubmittedDate", display: "Submitted" }

  ]


  const paymentForList = [{ value: 'System Visits', display: 'System Visits' }, { value: 'External Visits', display: 'External Visits' }, { value: 'All', display: 'All' },];
  const claimRejectionList = [{ value: 'Week', display: 'This Week' }, { value: 'Month', display: 'This Month' }, { value: 'All', display: 'All' },];

  const [isLoadingChargesClaimPayment, setIsLoadingChargesClaimPayment] = useState({});
  const [isLoadingAgingAppointments, setIsLoadingAgingAppointments] = useState({});

  const [baseOnChargerdisplay, setBaseOnChargerdisplay] = useState({
    value: '',
    display: '',
  })
  const [BaseOnPaymentdisplay, setBaseOnPaymentDisplay] = useState()
  const [baseOnDenieddisplay, setBaseOnDeniedDisplay] = useState()


  const Search_DataforSummary = {
    value: BaseDD[0]?.value,
    PaymentFor: paymentForList[2]?.value,
  }
  // const [baseOnSearchParamsummary, setBaseOnSearchParamsummary] = useState('Date of Service')
  // const [paymentForSearchParamsummary, setPaymentForSearchParamsummary] = useState('All')
  const [searchParamsummary, setSearchParamsummary] = useState(Search_DataforSummary)
  const [PaymentForAgingDisplay, setPaymentForAgingDisplay] = useState('All')
  const [baseOnAgingDisplay, setBaseOnAgingDisplay] = useState('Entry Date')







  ////////////////////////////////////////////////////////////////////////////////////////////////////////////



  const isHomeCareCheck = DropDowns.IsHomeCare == "true";

  const openSidebarSubMainTab = useSidebarSubMainTab();
  const [isLoading, setIsLoading] = useState(false)
  const [openTab, setOpenTab] = useState('')
  const API_URL = enumUtil.controller.Dashboard;
  const [viewDeniedVisits, setViewDeniedVisits] = useState('DeniedVisits');
  const [activeTab, setActiveTab] = useState({
    'Financial': { name: 'Graph' },
    'Aging': { name: 'Graph' },
    'Payment Received': { name: 'Graph' },
  });
  const [showDeniedVisits, setShowDeniedVisits] = useState('Claim')
  const [reloadChart, setReloadChart] = useState({})
  const [reloadData, setReloadData] = useState(false)
  // const [openLineFilter, setOpenLineFilter] = useState(false);

  // const [lineChartData, setLineChartData] = useState({})
  // const [donutData, setDonutData] = useState([])
  const [chargesNotBilledData, setChargesNotBilledData] = useState([])
  const [barData, setBarData] = useState([])



  const [denialVisitsData, setDenialVisitsData] = useState([])
  const [claimRejectionData, setClaimRejectionData] = useState([])

  const [gridHeaderr, handleGridHeaderr] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })

  // const [basedOnDateAging, setBasedOnDateAging] = useState("CreatedDate")
  // const [basedOnPaymentReceived, setBasedOnPaymentReceived] = useState("CreatedDate")
  const [basedOnRejection, setBasedOnRejection] = useState("Week")
  const [basedOnRejectionDisplay, setBasedOnRejectionDisplay] = useState("This Week")
  const [basedOnDenialClaim, setBasedOnDenialClaim] = useState("Reason")

  ////////====GridColumnHeader For Aging =========//////////
  const [gridHeaderAging, handleGridHeaderAging] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })


  ////////====GridColumnHeader For Payment Rec =========//////////
  const [gridHeaderPaymentRec, handleGridHeaderPaymentRec] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })






  const handleActiveTab = (tab, view) => {
    setActiveTab((prev) => ({
      ...prev, [tab]: { name: view }
    }))
  }

  const setDefaultData = (searchVal, subSearchVal) => {
    console.log("setDefaultDatasetDefaultData", searchVal, subSearchVal)
    switch (searchVal) {
      // case "Donut_Grid": setDonutData([]); break;
      case "Charges_Not_Billed":
        setIsLoadingChargesClaimPayment(prev => ({ ...prev, [searchVal]: true }));
        setChargesNotBilledData([]);
        break;
      case "Bar Chart":
        setBarData([]);
        setIsLoadingAgingAppointments(prev => ({ ...prev, [searchVal]: true }))
        break;
        break;
      case "Rejection":
        setIsLoadingChargesClaimPayment(prev => ({ ...prev, [searchVal]: true }));
        setClaimRejectionData([]);
        break;
      case "Denial Claim":
        setIsLoadingChargesClaimPayment(prev => ({ ...prev, [searchVal]: true }));
        setDenialVisitsData([]);
        break;

      default:
        // Optionally handle default case if needed
        break;
    }
  };

  const LoadData = (searchVal, subSearchVal) => {
    console.log("LoadData LoadData LoadData isFirstRender", searchVal, subSearchVal, isFirstRender)

    // setIsLoading(true)
    setDefaultData(searchVal, subSearchVal);

    let modal = 
    // searchVal === "Donut_Grid" ? 'GetGridData' :
      searchVal === 'Bar Chart' ? 'GetBarData' :
        searchVal === 'Charges_Not_Billed' ? 'Charges_Not_Billed' :
                searchVal === 'Rejection' ? 'Rejection' :
                  searchVal === 'Denial Claim' ? 'DenialClaim' :
                    '';
    let value = 
          searchVal === 'Rejection' ? { "Value": basedOnRejection } :
            searchVal === 'Denial Claim' ? { "Value": basedOnDenialClaim } :
                {};
    ///// To enable load after First render //////
      setIsFirstRender(false);
    // if (searchVal === 'Line Chart') {
    //   setIsFirstRender(false);
    // }
    //////////////////////////////////////////////
    ServerRequestProtected(API_URL + `/${modal}`, 'post', {
      "TableName": enumUtil.enumAPITableName.Dashboard,
      "SearchParam": searchVal,
      ...value
    }).then((response) => {

      // setIsLoading(false);

      // searchVal === "Donut_Grid" && setDonutsData(response);
      searchVal === "Charges_Not_Billed" && setChargesNotBilledData(response?.Donut);
      searchVal === "Bar Chart" && setBarsData(response);

      searchVal === "Denial Claim" && setDenialVisitsData(response);
      searchVal === "Denial Claim" && handleGridHeaderr({ defaultData: response })

      searchVal === "Rejection" && setClaimRejectionData(response);
      setReloadChart(prev => ({ ...prev, [searchVal]: !prev[searchVal] }))
    }).catch((error) => {
      // setIsLoading(false)

    }).finally(() => {

      searchVal === "Charges_Not_Billed" && setIsLoadingChargesClaimPayment((prev) => ({ ...prev, [searchVal]: false }));
      searchVal === "Denial Claim" && setIsLoadingChargesClaimPayment(prev => ({ ...prev, [searchVal]: false }));
      searchVal === "Rejection" && setIsLoadingChargesClaimPayment(prev => ({ ...prev, [searchVal]: false }));
      searchVal === "Bar Chart" && setIsLoadingAgingAppointments(prev => ({ ...prev, [searchVal]: false }));

    })
  }

  const totalClaimNo = denialVisitsData?.reduce((sum, item) => sum + Number(item?.ClaimNo), 0);


  // const setDonutsData = (response) => {
  //   const data = Object.fromEntries(response.Donut.map(item => [item.group, item]));
  //   setDonutData(() => ({ ...response, Donut: data }))
  // }
  const setBarsData = (response) => {
    setBarData(response);
    // const data = Object.fromEntries(response.Bar.map(item => [item.MonthNames, item]));
    // let seriesDatas = []
    // let keys = Object.keys(data);
    // for (let i = 0; i < keys?.length; i++) {
    //   seriesDatas.push(data?.[keys?.[i]])
    // }
    // setBarData(() => ({ ...response, Bar: seriesDatas }))



  }

  const fetchData = () => {
    // LoadData("Financial Summary");
    // LoadData("Donut_Grid");
    LoadData("Charges_Not_Billed");
    LoadData("Bar Chart");
    LoadData("Rejection");
    LoadData("Denial Claim");
  }

  useEffect(() => {
    fetchData();
  }, [reloadData])

  useEffect(() => {
    LoadData("Rejection");
  }, [basedOnRejection])

  useEffect(() => {
    LoadData("Denial Claim");
  }, [basedOnDenialClaim])

  const handleDeniedVisits = (val) => {
    setIsLoadingChargesClaimPayment(prev => ({ ...prev, 'Denial Claim': true }))
    switch (val) {
      case 'Claim':
        setShowDeniedVisits('Claim'); setDenialVisitsData([]); setBasedOnDenialClaim("Reason")
        break;

      case 'CPT':
        setShowDeniedVisits('CPT'); setDenialVisitsData([]); setBasedOnDenialClaim("CPT")
        break;

      case 'Group':
        setShowDeniedVisits('Group'); setDenialVisitsData([]); setBasedOnDenialClaim("DenialGroup")
        break;
    }
  }
  const [applyAllModal, setApplyAllModal] = useState(null)
  // let [setOpenLineChartFilter, searchLineChartFilterModal, lineChartFilterDiv] = useDashboardFilterHook(LoadData, 'Line Chart', setApplyAllModal, applyAllModal);
  // let [setOpenPaymentLineFilter, searchPaymentLineFilterModal, paymentLineFilterDiv, setBasedOnDatePaymentLine, basedOnDatePaymentLine, setPaymentLinePaymentForID, paymentLinePaymentForID] = useDashboardFilterHook(LoadData, 'Payment Line Chart', () => { }, applyAllModal);

  // let [setOpenFinancialFilter, searchFinancialFilterModal, financialFilterDiv, setBasedOnDateFinancial, basedOnDateFinancial, setPaymentForID, paymentForID] = useDashboardFilterHook(LoadData, 'Financial Summary', () => { }, applyAllModal);
  // let [setOpenPaymentReceivedFilter, searchPaymentReceivedFilterModal, paymentReceivedFilterDiv, setPaymentsForPaymentReceived, paymentsForPaymentReceived] = useDashboardFilterHook(LoadData, 'Payment Received', () => { }, applyAllModal);
  // let [setOpenAgingFilter, searchAgingFilterModal, agingFilterDiv, setBasedOnDateAging, basedOnDateAging, setPaymentIDAging, paymentForIDAging] = useDashboardFilterHook(LoadData, 'Aging_Payment_Received', () => { }, applyAllModal);
  // let [SetOpenPaymentsFilter, searchPaymnetFilterModal,paymentFilterDiv ,setPaymentID, paymentForIDs ] = useDashboardFilterHook(LoadData, 'KPI_Payment', () => { }, applyAllModal);

  // console.log(searchFinancialFilterModal, 'searchFinancialFilterModal');

  // useEffect(() => {
  //   LoadData("Payment Received");
  // }, [paymentsForPaymentReceived])

  const componentRef = useRef(null);
  const captureDataAndGeneratePDF = () => {
    setIsLoading(true); // Show loader
    const element = componentRef.current;
    // Temporarily adjust styles to ensure the full content is captured without shifting
    const originalOverflow = element.style.overflow;
    const originalBodyOverflow = document.body.style.overflow;
    // Hide overflow and ensure content is fully visible
    element.style.overflow = 'visible';
    document.body.style.overflow = 'hidden';
    // Wait for the next frame to ensure layout adjustments are rendered
    setTimeout(() => {
      html2canvas(element, {
        useCORS: true, // Allow external resources like fonts and images
        scrollX: 0,
        scrollY: 0,
        scale: 2, // Increase resolution for higher quality
        width: element.scrollWidth, // Capture full width
        height: element.scrollHeight, // Capture full height
      }).then((canvas) => {
        // Create a new PDF document
        const pdf = new jsPDF('p', 'mm', 'a4');
        // Get the image data
        const imgData = canvas.toDataURL('image/jpeg', 0.6); // Use JPEG with 70% quality
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 295; // A4 height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        // Add the image to the PDF
        let position = 0;
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        // If the image is taller than one page, add additional pages
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        // Save the PDF
        pdf.save('Dashboard.pdf');
        // Restore the original overflow
        element.style.overflow = originalOverflow;
        document.body.style.overflow = originalBodyOverflow;

        setIsLoading(false); // Hide loader
      }).catch(() => {
        // Restore original styles on error
        element.style.overflow = originalOverflow;
        document.body.style.overflow = originalBodyOverflow;
        setIsLoading(false); // Hide loader
      });
    }, 100); // Adjust timeout if needed
  };

  const handleChange = (e) => {
    let { name, value } = e.target
    if (name === 'PaymentFor') {
      // setPaymentForSearchParam(value);
      // setPaymentLinePaymentForID(value);
      // setSearchParam({ ...searchParam, PaymentFor: value })

    }
    if (name === 'PaymentForAging') {
      // setPaymentForAgingDisplay(value)
    }
    if (name === 'BaseOnCharger') {
      setBaseOnChargerdisplay({ display: value })
    }
    if (name === 'BaseOnPayment') {
      setBaseOnPaymentDisplay(value)
    }
    if (name === 'BaseOnDenied') {
      setBaseOnDeniedDisplay(value)

    }
    if (name === 'PaymentType') {
      setBasedOnRejectionDisplay(value)
    }
  }
  const handleSelectedDataa = (selectedData, name, type) => {
    // setIs(false)
    if (type === 'client' && !isNull(selectedData)) {
      if (name === 'PaymentFor') {
        // setSearchParam({ ...searchParam, PaymentFor: selectedData.value + "", });

        // setPaymentLinePaymentForID(selectedData.value + "");
        // setPaymentForSearchParam(selectedData.display);

        // setIs(false);

      }
      else if (name === 'BaseOnCharger') {
        setBaseOnChargerdisplay({ display: selectedData.display, value: selectedData.value + "" })
        // setBasedOnDateAging(selectedData.value + "")
      }
      else if (name === 'BaseOnPayment') {
        // setSearchParam({ ...searchParam, PaymentFor: selectedData.value + "", })
        setBaseOnPaymentDisplay(selectedData.display)
      }
      else if (name === 'BaseOnDenied') {
        // setSearchParam({ ...searchParam, PaymentFor: selectedData.value + "", })
        setBaseOnDeniedDisplay(selectedData.display)
      }

      else if (name === 'PaymentType') {
        setBasedOnRejectionDisplay(selectedData.display)
        setBasedOnRejection(selectedData.value + "")
        if (selectedData.value !== basedOnRejection) {
          setIsLoadingChargesClaimPayment(prev => ({ ...prev, "Rejection": true }))
        }
      }

    } else {
      if (name === 'PaymentForSummary') {

      }
      else if (name === 'Baseonsummary') {

      }
      else if (name === 'PaymentType') {
        setBasedOnRejectionDisplay('');
        setBasedOnRejection("");
      }
    }
    return selectedData
  }

  // const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
  // let data = {
  //     name: 'ChildCustomView',
  //     type: "ViewEOB",

  //     data : {
  //       name: "View EOB",
  //       data: {
  //           id: "20278",
  //           type: "ERA"
  //       }
  //     }
  // };

  //  let paymentObjs = {
  //     "group": "Payments",
  //     "Total": "164.90",
  //     "PreviousMonthAmount": "12542.45",
  //     "CurrentMonthAmount": "164.90",
  //     "LastWeekAmount": "164.90",
  //     "Percentage": "-98.685264840601318",
  //     "YTD": "13741464.08",
  //     // "data": [8.27, 10000, 2222, 164.9],
  //     "DateRange": [
  //       "08/10/2025 - 08/16/2025",
  //       "08/17/2025 - 08/23/2025",
  //       "08/24/2025 - 08/30/2025",
  //       "08/31/2025 - 09/06/2025"
  //     ],
  //     "series": [
  //       { "name": "Ins. Pay", "data": [10008.27, 2000, 12000, 64.9] },
  //       { "name": "Pat. Pay", "data": [3.27, 11000, 22, 64.9] }
  //     ]
  //   };
  return (
    <>
      {isLoading ? <Loader /> : null}
      {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
      <div className="position-relative dashboard_screen_size hover-scrollbar" ref={componentRef}>
        {/* <ContentReceiver /> */}
        <div className="row m-0 mt-2">
          <div className="col-md-12 d-flex flex-column gap-2">
            <div className="border-0 card_tabs filter-row position-relative">
              <div className="ar-dashborad-icons d-flex flex-column gap-1">
                <div className="refresh-icon app_tooltip left" onClick={() => setReloadData(prev => !prev)}>
                  <i className="icon-spinner-1"></i>
                  <p class="tool_tip xsm_text text-light">Refresh</p>
                </div>
                <div className="za_printer-icon app_tooltip left" onClick={captureDataAndGeneratePDF}>
                  <span class="icon-Group-1000002858 fs-12"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span></span>
                  <p class="tool_tip xsm_text text-light">Print</p>
                </div>
              </div>
              <BillingPerformance reloadData={reloadData} />
            </div>
            <KPISection reloadData={reloadData} />
            <FinancialSummary reloadData={reloadData} isHomeCareCheck={isHomeCareCheck} />
            <div className="row m-0">
              <div className="col-md-2 px-0 dashboard-charges charges-not-build">
                <div className="border-0 card_tabs filter-row  p-2 h-100">
                  <div className="d-flex align-items-center justify-content-between gap-2 za_br_light br-bottom-1 pb-1-5 mb-06-px">
                    <p className="heading text-black fs-15">Charges Not Billed</p>
                    {/* <div className="d-flex align-items-center gap-1"> */}
                    {isLoadingChargesClaimPayment?.['Charges_Not_Billed'] ?
                      (<div className="ar-small-loader last_loader">
                        <div className="circle circle1"></div>
                        <div className="circle circle2"></div>
                      </div>) : <></>}
                    {/* <p className="za-dot text fst-italic fs-11">This Year</p> */}
                  </div>
                  <div>
                    {/* {donutData?.Donut?.['Charges Not Billed']?.data.length > 0 ?
                      <DonutChart type={'Charges Not Billed'} data={donutData?.Donut?.['Charges Not Billed']?.data} /> : <div style={{ height: 230 }}></div>} */}
                    {chargesNotBilledData.length > 0 ?
                      <DonutChart type={'Charges Not Billed'} data={chargesNotBilledData} /> : <div style={{ height: 230 }}></div>}
                  </div>
                </div>
              </div>
              <div className="col-md-5 pe-0">

                <div className="border-0 card_tabs filter-row p-2">
                  <div className="d-flex align-items-center justify-content-between gap-2 za_br_light br-bottom-1 pb-1-5 mb-06-px">
                    <p className="heading text-black fs-15">Claim Denials/Rejections</p>
                    {/* <div className="d-flex align-items-center gap-1"> */}
                    {viewDeniedVisits === 'DeniedVisits' &&
                      ((isLoadingChargesClaimPayment?.['Denial Claim']) ?
                        (<div className="ar-small-loader last_loader">
                          <div className="circle circle1"></div>
                          <div className="circle circle2"></div>
                        </div>) : <></>)}
                    {viewDeniedVisits === 'ClaimRejections' &&
                      ((isLoadingChargesClaimPayment?.['Rejection']) ?
                        (<div className="ar-small-loader last_loader">
                          <div className="circle circle1"></div>
                          <div className="circle circle2"></div>
                        </div>) : <></>)}
                    {/* <p className="za-dot text fst-italic fs-11">This Year</p> */}
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="views d-flex align-items-center">
                      <p className={`text fs-11  py-1 px-2 cursor-pointer d-flex align-items-center gap-1 h-26px ar-light-color ${viewDeniedVisits === 'DeniedVisits' ? 'active' : ''}`} onClick={() => setViewDeniedVisits('DeniedVisits')}>Denied Visits
                        <span className="ar_count position-static text-white pt-0 w-auto px-1">{totalClaimNo || '0'}</span>
                      </p>
                      <p className={`text fs-10  py-1 px-2 cursor-pointer d-flex align-items-center gap-1 h-26px ar-light-color ${viewDeniedVisits === 'ClaimRejections' ? 'active' : ''}`} onClick={() => setViewDeniedVisits('ClaimRejections')}>Claim Rejections
                        <span className="ar_count position-static text-white pt-0 w-auto px-1">{claimRejectionData?.length || '0'}</span> </p>
                    </div>
                  </div>
                  {viewDeniedVisits === 'DeniedVisits' ?
                    <DeniedVisits showDeniedVisits={showDeniedVisits} denialVisitsData={denialVisitsData} handleDeniedVisits={handleDeniedVisits} setDenialVisitsData={setDenialVisitsData} isLoadingChargesClaimPayment={isLoadingChargesClaimPayment} gridHeaderr={gridHeaderr} handleGridHeaderr={handleGridHeaderr} /> :
                    <div class="">
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="heading">Claim Rejection</p>
                        <div class="d-flex align-items-center gap-2">
                          <div className="w-120px">
                            <SuperSearchList
                              type="client"
                              id='PaymentType'
                              name='PaymentType'
                              searchValue={basedOnRejectionDisplay}
                              data={claimRejectionList}
                              onChange={(e) => handleChange(e)}
                              getSelectedData={handleSelectedDataa}
                              icon={'Simple'}
                              sup_btn='sup_btn'
                              sup_inp='superSearchVisitInp'
                            />
                          </div>
                          {/* <div class="input">
                            <select
                              class="form-control"
                              id="PaymentType"
                              name="PaymentType"
                              value={basedOnRejection}
                              onChange={(e) => {
                                if(basedOnRejection !== e.target.value){
                                  setIsLoadingChargesClaimPayment(prev => ({ ...prev, 'Rejection': true}));
                                }
                                setBasedOnRejection(e.target.value);
                              }}>
                              <option value="Week">This Week</option>
                              <option value="Month">This Month</option>
                              <option value="All">All</option>
                            </select>
                          </div> */}
                        </div>
                      </div>
                      <div className="position-relative">
                        {claimRejectionData?.length > 0 ?
                          <>
                            <Table
                              columns={[
                                {
                                  key: 'ClaimNo', name: '# Claims', minWidth: 65, width: 65,
                                  renderCell: ({ row }) => {
                                    return (
                                      <button className="btn btn-link p-0"
                                        onClick={() => openSidebarSubMainTab(`EDI Reports-7812-{"RejectionMsg":"${row?.Value}"}`)}

                                      >{row.ClaimNo}
                                      </button>
                                    )
                                  }
                                },
                                {
                                  key: 'Amount', name: 'Amount',
                                  renderCell: ({ row }) => {
                                    return (
                                      <div >{<AmountFormatter amount={row.Amount} />}</div>
                                    )
                                  }
                                },
                                { key: 'RejectionMsg', name: 'Rejection' }
                              ]}
                              dynamicClass='BorderLess-Grid DataGrid-Table hk-exp-table mt-2 overflow-auto Scroll-width'
                              rowHeight={25}
                              rows={claimRejectionData || []}
                              height='153px'
                              hidePagination={true}
                              isLoading={true}
                              hideColClass={'hide'}
                            /></> :
                          (<div className="act-cal-nodata" style={{ height: 166 }}>{(!isLoadingChargesClaimPayment?.['Rejection']) && <NoDataFound isLoading={false} rows={claimRejectionData} />}</div>)}
                      </div>
                    </div>}
                </div>
              </div>
              <div className="col-md-5 pe-0">
                <PaymentReceived reloadData={reloadData} />
              </div>
            </div>
            <div className="row m-0 mb-1">
              <div className="col-md-7 p-0">
                <Aging reloadData={reloadData} isHomeCareCheck={isHomeCareCheck} />
              </div>
              {isHomeCareCheck ? null :
                <div className="col-md-5 pe-0">
                  <div className="filter-row border-0 card_tabs p-2">
                    <div className="d-flex justify-content-between align-items-center position-relative za_br_light br-bottom-1 pb-1-5 mb-06-px">
                      <div className="d-flex align-items-center gap-2">
                        <p className="heading text-black fs-15">Appointments</p>
                        <p className="za-dot text fst-italic fs-11">Last Five Days</p>
                      </div>

                      <div className="d-flex align-items-center gap-2">
                        {isLoadingAgingAppointments?.["Bar Chart"] ?
                          <div className="ar-small-loader last_loader">
                            <div className="circle circle1"></div>
                            <div className="circle circle2"></div>
                          </div> : <></>}

                        <div className="d-flex align-items-center gap-1">
                          <p className='text'>Total Appointments:</p>
                          <p className='text'>12</p>
                        </div>
                      </div>
                    </div>
                    <div className="row m-0 gap-20">
                      <div className="col-md-12 px-0">
                        {barData?.Bar?.length > 0 ?
                          // <DonutChart type={'Appointments'} data={donutData?.Donut?.['Appointments']?.data}/>
                          <AppointmentsBarChart type={'Appointments'} data={barData?.Bar} />
                          : <div style={{ height: 205 }}></div>}
                      </div>
                      {/* <div className="col-md-12 d-flex justify-content-between align-items-center ar_monthly_appointment">
                      <p className="text d-flex align-items-center gap-5">Today’s Appointment <span className="heading lg">{donutData?.Donut?.['Appointments']?.TodayAppointment}</span></p>
                      <p className="text"><i className="icon-icon-arrow-top-right me-1"></i><span className="heading appointment">27%</span> Yesterday</p>
                    </div> */}
                      {/* <div className="col-md-12 d-flex justify-content-between align-items-center ar_monthly_appointment">
                      <p className="text d-flex align-items-center gap-30">This Month Appointments <span className="heading lg">{donutData?.Donut?.['Appointments']?.ThisMonthAppointment}</span></p>
                      <p className="text"><i className="icon-icon-arrow-top-right me-1"></i><span className="heading appointment">27%</span> From June</p>
                    </div> */}
                      {/* <div className="col-md-12 d-flex justify-content-between align-items-center ar_monthly_appointment">
                      <p className="text d-flex align-items-center gap-30">This Year Appointments <span className="heading lg">{donutData?.Donut?.['Appointments']?.ThisMonthAppointment}</span></p>
                      <p className="text"><i className="icon-icon-arrow-top-right me-1"></i><span className="heading appointment">27%</span> From June</p>
                    </div> */}
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;

const DeniedVisits = memo(({ showDeniedVisits, denialVisitsData, setDenialVisitsData, handleDeniedVisits, isLoadingChargesClaimPayment, handleGridHeaderr, gridHeaderr }) => {
  const openSidebarSubMainTab = useSidebarSubMainTab();
  console.log('denialVisitsData', isLoadingChargesClaimPayment);
  let loading =
    <div className="act-cal-nodata" style={{ height: 169 }}>
      {!isLoadingChargesClaimPayment?.['Denial Claim'] && <NoDataFound isLoading={false} rows={denialVisitsData} />}
    </div>;
  return (
    <div className="position-relative">
      <div className="d-flex align-items-center justify-content-between mt-2">
        <p className="heading">Denial by {showDeniedVisits}</p>
        <div className="d-flex align-items-center gap-15">
          <label className="ar_radio-btn d-flex align-items-center gap-6">
            <input
              type="radio"
              id="Claim"
              checked={showDeniedVisits === 'Claim'}
              onChange={() => { handleDeniedVisits('Claim') }}
            />
            <p className="text ar-orange-text" htmlFor="Claim">By Denied Code</p>
          </label>
          <label className="ar_radio-btn d-flex align-items-center gap-6">
            <input
              type="radio"
              id="CPT"
              checked={showDeniedVisits === 'CPT'}
              onChange={() => { handleDeniedVisits('CPT') }}
            />
            <p className="text ar-orange-text" htmlFor="CPT">By CPT</p>
          </label>
          <label className="ar_radio-btn d-flex align-items-center gap-6">
            <input
              type="radio"
              id="Group"
              checked={showDeniedVisits === 'Group'}
              onChange={() => { handleDeniedVisits('Group') }}
            />
            <p className="text ar-orange-text" htmlFor="Group">By Group</p>
          </label>
        </div>
      </div>
      {showDeniedVisits === 'Claim' ?
        denialVisitsData?.length > 0 ?
          <Table
            key={showDeniedVisits}
            columns={[
              {
                key: 'ClaimNo',
                name: (<GridColumnHeader gridHeader={gridHeaderr} handleGridHeader={handleGridHeaderr}
                  iconName={'iicon-Icon-awesome-user-tie'} headerName={'# Claims'} sortIcon={true} type={'number'} colKey={'ClaimNo'} data={denialVisitsData} setData={setDenialVisitsData} />),
                // name: '# Claims',

                // minWidth: 65, width: 65,
                renderCell: ({ row }) => {
                  return (
                    <button className="btn btn-link p-0" onClick={() => openSidebarSubMainTab(`Account Receivables-7222-{"DeniedCode":"${row.Value}"}`)}>{row.ClaimNo}</button>
                  )
                }
              },
              {
                key: 'Amount',
                name: (<GridColumnHeader gridHeader={gridHeaderr} handleGridHeader={handleGridHeaderr}
                  iconName={'iicon-Icon-awesome-user-tie'} headerName={'Amount'} sortIcon={true} type={'string'} colKey={'Amount'} data={denialVisitsData} setData={setDenialVisitsData} />),
                // name: 'Amount',
                renderCell: ({ row }) => {
                  return (
                    <div >{<AmountFormatter amount={row.Amount} />}</div>
                  )
                }
              },
              {
                key: 'Reason',
                name: (<GridColumnHeader gridHeader={gridHeaderr} handleGridHeader={handleGridHeaderr}
                  iconName={'iicon-Icon-awesome-user-tie'} headerName={'Reason'} sortIcon={true} type={'string'} colKey={'Reason'} data={denialVisitsData} setData={setDenialVisitsData} />),

                // name: 'Reason',
                width: 320,
                renderCell: ({ row }) => {
                  return (
                    <div className="validation_message" title={row.Reason}>{row.Reason}</div>
                  );
                },
              }
            ]}
            dynamicClass='BorderLess-Grid DataGrid-Table hk-exp-table mt-2 overflow-auto Scroll-width'
            rowHeight={25}
            rows={denialVisitsData || []}
            height='153px'
            hidePagination={true}
            isLoading={true}
            hideColClass={'hide'}
          /> : loading :

        showDeniedVisits === 'CPT' ?
          denialVisitsData.length > 0 ?
            <Table
              key={showDeniedVisits}
              columns={[
                {
                  key: 'Value',
                  name: (<GridColumnHeader gridHeader={gridHeaderr} handleGridHeader={handleGridHeaderr}
                    iconName={'iicon-Icon-awesome-user-tie'} headerName={'CPT'} sortIcon={true} type={'string'} colKey={'Value'} data={denialVisitsData} setData={setDenialVisitsData} />),
                  //  name: 'CPT', 
                  //  minWidth: 65, width: 65,
                  renderCell: ({ row }) => {
                    // Add " " around value which is Alphanumeric
                    return (<button className="btn btn-link p-0" onClick={() => openSidebarSubMainTab(`Account Receivables-7222-{"CPT":"${row.Value}"}`)}>{row.Value}</button>)
                  }
                },
                {
                  key: 'Amount',
                  name: (<GridColumnHeader gridHeader={gridHeaderr} handleGridHeader={handleGridHeaderr}
                    iconName={'iicon-Icon-awesome-user-tie'} headerName={'Amount'} sortIcon={true} type={'string'} colKey={'Amount'} data={denialVisitsData} setData={setDenialVisitsData} />),
                  // name: 'Amount',
                  renderCell: ({ row }) => {

                    return (
                      <div >{<AmountFormatter amount={row.Amount} />}</div>
                    )
                  }
                },
                {
                  key: 'Reason',
                  name: (<GridColumnHeader gridHeader={gridHeaderr} handleGridHeader={handleGridHeaderr}
                    iconName={'iicon-Icon-awesome-user-tie'} headerName={'Reason'} sortIcon={true} type={'string'} colKey={'Reason'} data={denialVisitsData} setData={setDenialVisitsData} />),
                  // name: 'Reason', 
                  // width: 320,
                  renderCell: ({ row }) => {
                    return (
                      <div className="validation_message" title={row.Reason}>{row.Reason}</div>
                    );
                  },
                }
              ]}
              dynamicClass='BorderLess-Grid DataGrid-Table hk-exp-table mt-2 overflow-auto Scroll-width'
              rowHeight={25}
              rows={denialVisitsData || []}
              height='153px'
              hidePagination={true}
              isLoading={true}
              hideColClass={'hide'}
            /> : loading :

          showDeniedVisits === 'Group' ?
            denialVisitsData.length > 0 ?
              <Table
                key={showDeniedVisits}
                columns={[
                  {
                    key: 'Value',
                    // name: 'Group', 
                    name: (<GridColumnHeader gridHeader={gridHeaderr} handleGridHeader={handleGridHeaderr}
                      iconName={'iicon-Icon-awesome-user-tie'} headerName={'Group'} sortIcon={true} type={'string'} colKey={'Value'} data={denialVisitsData} setData={setDenialVisitsData} />),

                    // minWidth: 65, width: 65,
                    renderCell: ({ row }) => {
                      // [{"DenialGroup":"Rejected by CH"}]
                      return (<button className="btn btn-link p-0" onClick={() => openSidebarSubMainTab(`Account Receivables-7222-{"DeniedGroup":${row?.DenialGroupID}}`)}>{row.Value}</button>)
                    }
                  },
                  {
                    key: 'amount',
                    name: (<GridColumnHeader gridHeader={gridHeaderr} handleGridHeader={handleGridHeaderr}
                      iconName={'iicon-Icon-awesome-user-tie'} headerName={'Amount'} sortIcon={true} type={'string'} colKey={'Amount'} data={denialVisitsData} setData={setDenialVisitsData} />),
                    // name: 'Amount',
                    renderCell: ({ row }) => {
                      return (
                        <div >{<AmountFormatter amount={row.Amount} />}</div>
                      )
                    }
                  },
                  {
                    key: 'Reason',
                    name: (<GridColumnHeader gridHeader={gridHeaderr} handleGridHeader={handleGridHeaderr}
                      iconName={'iicon-Icon-awesome-user-tie'} headerName={'Reason'} sortIcon={true} type={'string'} colKey={'Reason'} data={denialVisitsData} setData={setDenialVisitsData} />),
                    // name: 'Reason',
                    width: 320,
                    renderCell: ({ row }) => {
                      return (
                        <div className="validation_message" title={row.Reason}>{row.Reason}</div>
                      );
                    },
                  }
                ]}
                dynamicClass='BorderLess-Grid DataGrid-Table hk-exp-table mt-2 overflow-auto Scroll-width'
                rowHeight={25}
                rows={denialVisitsData || []}
                height='153px'
                hidePagination={true}
                isLoading={true}
                hideColClass={'hide'}
              /> : loading
            : <></>}
      {/* {denialVisitsData.length === 0  &&(!isLoadingChargesClaimPayment?.['Denial Claim'] && 
            <div className="act-cal-nodata" style={{ height: 169 }}><NoDataFound isLoading={false} rows={denialVisitsData} /></div>)} */}
    </div>)
});
